module.exports = "/assets/65b046fb256850fe440d2c5dd7abd6f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/V9.png
// module id = 3037
// module chunks = 0